<script lang="ts">
  import { Label } from "$lib/components/ui/label";
  import { t } from "$lib/i18n";

  let { title = $bindable(), isReadonly = false, invalid = false }: { title: string, isReadonly?: boolean, invalid?: boolean } = $props();
</script>

<div class="grid grid-cols-4 items-center gap-4">
  <Label for="title">{$t('fields.title')}</Label>
  <input
    readonly={isReadonly}
    id="title"
    bind:value={title}
    placeholder={$t('fields.titlePlaceholder')}
    aria-invalid={invalid ? "true" : undefined}
    class="col-span-3 border-input bg-background placeholder:text-muted-foreground shadow-xs min-w-0 rounded-md border px-3 py-1 text-base outline-none transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm aria-invalid:border-destructive aria-invalid:ring-destructive/20"
  />
</div>
